import { Pipe, PipeTransform } from '@angular/core'

import { Enums } from '@cyborg-monorepo/hunter/common'
import { BadgeVariant } from '@hyperkit'

@Pipe({
  name: 'outcomeBadge',
  pure: true,
  standalone: false,
})
export class OutcomeBadgePipe implements PipeTransform {
  transform(outcome: Enums.OutcomeEnum): BadgeVariant {
    switch (outcome) {
      case Enums.OutcomeEnum.DETECTION:
        return 'information'
      case Enums.OutcomeEnum.ESCALATED:
        return 'error'
      case Enums.OutcomeEnum.NO_FINDINGS:
        return 'success'
      case Enums.OutcomeEnum.VISIBILITY_GAP:
        return 'warning'
      default:
        return 'information'
    }
  }
}
